import type { SeriesSummary } from '@contracts/series';
import { since, until } from '../lib/time';

type Timed = Pick<SeriesSummary, 'instances' | 'lastMetAt' | 'nextAt'>;

/**
 * How many times a series has met and when last — or, nothing of it recorded
 * yet, that it has not and when it first will (2026-10-08: a series named on a
 * meeting still to come had been in no list at all).
 */
export function seriesWhen(s: Timed, unit: 'meeting' | 'instance' = 'meeting'): string {
  if (s.instances > 0 && s.lastMetAt) {
    return `${s.instances} ${s.instances === 1 ? unit : `${unit}s`} · last ${since(s.lastMetAt)}`;
  }
  return s.nextAt ? `no recordings yet · first ${until(s.nextAt)}` : 'no recordings yet';
}

/** Newest first; a series still to meet, by when it will. */
export function byLastMet(a: Timed, b: Timed): number {
  return metAt(b) - metAt(a);
}

function metAt(s: Timed): number {
  return Date.parse(s.lastMetAt ?? s.nextAt ?? '') || 0;
}
